import type FindControlViewState from 'owa-recipient-types/lib/types/FindControlViewState';
import SubstrateSearchScenario from 'owa-search-service/lib/data/schema/SubstrateSearchScenario';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export default function is3SLoggingSupported(viewState: FindControlViewState): boolean {
    const searchScenario = viewState.searchScenario;
    return (
        isGlobalFeatureEnabled('rp-3STelemetryEvents') &&
        searchScenario !== undefined &&
        searchScenario === SubstrateSearchScenario.MailCompose
    );
}
